module.exports = __webpack_public_path__ + "static/media/incremental.ffb62368.svg";